import Vue from 'vue';
import router from '../router';

import VueMatomo from 'vue-matomo'
Vue.use(VueMatomo, {
  host: 'https://matomo.groovetech.io',
  siteId: 3,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
});

import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('vue-apex-charts', VueApexCharts);

import { HalfCircleSpinner } from 'epic-spinners';
Vue.component('half-circle-spinner', HalfCircleSpinner);

import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
Vue.use(FormWizard);
Vue.use(TabContent);

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
Vue.use(DateRangePicker);
Vue.component('date-range-picker', DateRangePicker);

import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
Vue.use(VueFormWizard);

import vSelect from 'vselect-component';
Vue.use(vSelect);
Vue.component('v-select', vSelect);

import VueNumeric from 'vue-numeric';
Vue.use(VueNumeric);

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
Vue.component('multiselect', Multiselect);

import Vuetable from 'vuetable-2';
Vue.use(Vuetable);
Vue.component('vuetable', Vuetable);

import { ClientTable, ServerTable } from 'vue-tables-2';
Vue.use(ClientTable);

Vue.use(ServerTable, {}, false, () => ({
  framework: 'tailwind',
  table: 'bg-white text-center rounded border border-grey-300',
  row: 'row',
  column: 'col-md-12',
  label: 'font-semibold text-sm text-grey-700',
  input:
    'ml-2 h-8 outline-none px-4 bg-white border border-solid border-grey-200 rounded-lg',
  select: 'w-full h-full outline-none rounded-lg px-4 bg-white',
  field: '',
  inline: 'form-inline',
  right: 'float-right',
  left: 'float-left',
  center: 'text-center',
  contentCenter: 'justify-content-center',
  nomargin: 'm-0',
  groupTr: 'table-info',
  small: '',
  button: 'btn btn-secondary text-secondary-darker',
  dropdown: {
    container: 'dropdown',
    trigger: 'dropdown-toggle',
    menu: 'dropdown-menu',
    content: '',
    item: 'dropdown-item',
    caret: 'caret',
  },
  pagination: {
    nav: 'paginationNav',
    count: 'paginationCount',
    wrapper: 'flex flex-row justify-end',
    list: 'mt-4 flex flex-row justify-end',
    item:
      'bg-white px-3 py-1 border-r border-t border-b border-grey-100 text-black no-underline',
    link: '',
    next: 'paginationNext',
    prev: 'paginationPrev',
    active: 'bg-blue text-white paginationActive',
    disabled: 'disabled paginationDisabled',
  },
}));

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import VueCurrencyInput from 'vue-currency-input';
Vue.use(VueCurrencyInput);

import wysiwyg from 'vue-wysiwyg';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
Vue.use(wysiwyg, {});

import 'vue-search-select/dist/VueSearchSelect.css';

import vueDebounce from 'vue-debounce';
Vue.use(vueDebounce);

import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true,
});

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
Vue.filter('numFormat', numFormat(numeral));

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);
